/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactDOM from 'react-dom';
import './Modal.scss';
import { Button } from 'components';

const Modal = ({
  title,
  customClassName,
  children,
  onClose,
  showModal,
  withPadding,
  isCloseHidden,
  isWarning,
  isConfirm,
  onConfirm,
  isCatalogue,
}) => {
  const classes = classNames({
    modal: true,
    'modal--withPadding': withPadding,
    'modal--isWarning': isWarning,
    'modal--catalogue': isCatalogue,
  });
  if (showModal) {
    return ReactDOM.createPortal(
      <div className="layout modal-overlay">
        <section className={`${classes} ${customClassName}`}>
          {!isCloseHidden && !isWarning && <span className="modal__close" onClick={onClose} />}
          {title && (
          <header className="modal__header">
            <h5 className="modal__header__title">{title}</h5>
          </header>
          )}
          <div className="modal__content">
            {children}
          </div>
          <div className="modal__actions">
            {isWarning
              ? <Button isPrimary value="Ok" onButtonClick={onClose} />
              : isConfirm
                ? (
                  <div className="confirm-options">
                    <Button isPrimary isOutlineButton value="Cancel" onButtonClick={onClose} />
                    <Button isPrimary value="Confirm" onButtonClick={onConfirm} />
                  </div>
                ) : null}
          </div>
        </section>
      </div>,
      document.querySelector('#app'),
    );
  }
  return null;
};

Modal.propTypes = {
  /** Title */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** custom class for general popup */
  customClassName: PropTypes.string,
  /** content for general popup */
  children: PropTypes.node,
  /** close popup function */
  onClose: PropTypes.func,
  /** isPopupShowing */
  showModal: PropTypes.bool,
  /** with padding */
  withPadding: PropTypes.bool,
  /** Hide close button */
  isCloseHidden: PropTypes.bool,
  /** is a warning popup */
  isWarning: PropTypes.bool,
  /** Is confirmation popup */
  isConfirm: PropTypes.bool,
  /** Confirm function */
  onConfirm: PropTypes.func,
  /** is modal catalogue */
  isCatalogue: PropTypes.bool,
};

Modal.defaultProps = {
  title: null,
  customClassName: '',
  children: <></>,
  showModal: false,
  onClose: () => {},
  withPadding: false,
  isCloseHidden: false,
  isWarning: false,
  isConfirm: false,
  onConfirm: () => {},
  isCatalogue: false,
};

export default Modal;
